import { normalizeSavingsRangeToApiIso } from 'shared/lib/reportDatePresets';

import type { ComplianceFilters } from '../types/ReportCatalogComplianceSchema';

export const buildCatalogComplianceBody = (
    filters: ComplianceFilters,
): ComplianceFilters => {
    const dates = normalizeSavingsRangeToApiIso(
        filters.dateFrom,
        filters.dateTo,
    );

    return {
        ...dates,
        ...(filters.propertyIds?.length
            ? { propertyIds: filters.propertyIds }
            : {}),
    };
};
